import { IConfiguration, Platform, Tenant } from './IConfiguration';

export default class ModelicalConfiguration implements IConfiguration {
    // domains of environments (hardcoded - react doesn't allow changes on runtime)
    readonly modelicalDevDomain = 'dev.modelical.io';
    readonly modelicalPreDomain = 'pre.modelical.io';
    readonly modelicalProductionDomain = 'modelical.io';

    // configuration attributes
    auth: any | undefined;
    parentUrl: string | undefined;
    adminMicroserviceUrl: string;
    proxyMicroserviceUrl: string;
    syncMicroserviceUrl: string;
    mioAdminUrl: string;
    parentDomain: string;
    cookiesSubfix: string;
    procoreUrl: string;
    aconexUrl: string;

    constructor() {
        // set up configuration attributes based on environment
        if (window.location.hostname.endsWith('link.' + this.modelicalDevDomain)) {
            this.auth = {
                auth: {
                    clientId: '93a915f6-5a3e-48e7-810a-6fa4a88a6a46',
                    authority: 'https://login.microsoftonline.com/d8c21a0f-8e79-48d2-9314-075f557b317d',
                    redirectUri: `https://link.${this.modelicalDevDomain}`,
                    postLogoutRedirectUri: `https://link.${this.modelicalDevDomain}`,
                    navigateToLoginRequestUrl: true,
                    OIDCOptions: {
                        defaultScopes: ['93a915f6-5a3e-48e7-810a-6fa4a88a6a46/.default'],
                    },
                },
                cache: {
                    cacheLocation: 'localStorage',
                    storeAuthStateInCookie: false,
                },
            };

            this.parentUrl = `https://dev.modelical.io`;
            this.adminMicroserviceUrl = `https://admin.link.${this.modelicalDevDomain}`;
            this.proxyMicroserviceUrl = `https://proxy.link.${this.modelicalDevDomain}`;
            this.syncMicroserviceUrl = `https://sync.link.${this.modelicalDevDomain}`;
            this.mioAdminUrl = `https://admin.api.${this.modelicalDevDomain}`;
            this.parentDomain = 'dev.modelical.io';
            this.cookiesSubfix = 'DevModelicalIo';
            this.procoreUrl = 'https://login-sandbox.procore.com';
            this.aconexUrl = 'https://constructionandengineering-ea.oraclecloud.com';
        } else if (window.location.hostname.endsWith('link.' + this.modelicalPreDomain)) {
            this.auth = {
                auth: {
                    clientId: '7238211b-255b-46e4-9c38-5461562f777e',
                    authority: 'https://login.microsoftonline.com/d8c21a0f-8e79-48d2-9314-075f557b317d',
                    redirectUri: `https://link.${this.modelicalPreDomain}`,
                    postLogoutRedirectUri: `https://link.${this.modelicalPreDomain}`,
                    navigateToLoginRequestUrl: true,
                    OIDCOptions: {
                        defaultScopes: ['7238211b-255b-46e4-9c38-5461562f777e/.default'],
                    },
                },
                cache: {
                    cacheLocation: 'localStorage',
                    storeAuthStateInCookie: false,
                },
            };

            this.parentUrl = `https://pre.modelical.io`;
            this.adminMicroserviceUrl = `https://admin.link.${this.modelicalPreDomain}`;
            this.proxyMicroserviceUrl = `https://proxy.link.${this.modelicalPreDomain}`;
            this.syncMicroserviceUrl = `https://sync.link.${this.modelicalPreDomain}`;
            this.mioAdminUrl = `https://admin.api.${this.modelicalPreDomain}`;
            this.parentDomain = 'pre.modelical.io';
            this.cookiesSubfix = 'PreModelicalIo';
            this.procoreUrl = 'https://login.procore.com';
            this.aconexUrl = 'https://constructionandengineering.oraclecloud.com';
        } else {
            this.auth = {
                auth: {
                    clientId: '68b966a5-dad5-42f3-88d4-4e919f3b8f6e',
                    authority: 'https://login.microsoftonline.com/d8c21a0f-8e79-48d2-9314-075f557b317d',
                    redirectUri: `https://link.${this.modelicalProductionDomain}`,
                    postLogoutRedirectUri: `https://link.${this.modelicalProductionDomain}`,
                    navigateToLoginRequestUrl: true,
                    OIDCOptions: {
                        defaultScopes: ['68b966a5-dad5-42f3-88d4-4e919f3b8f6e/.default'],
                    },
                },
                cache: {
                    cacheLocation: 'localStorage',
                    storeAuthStateInCookie: false,
                },
            };

            this.parentUrl = `https://modelical.io`;
            this.adminMicroserviceUrl = `https://admin.link.${this.modelicalProductionDomain}`;
            this.proxyMicroserviceUrl = `https://proxy.link.${this.modelicalProductionDomain}`;
            this.syncMicroserviceUrl = `https://sync.link.${this.modelicalProductionDomain}`;
            this.mioAdminUrl = `https://admin.api.${this.modelicalProductionDomain}`;
            this.parentDomain = 'modelical.io';
            this.cookiesSubfix = 'ModelicalIo';
            this.procoreUrl = 'https://login.procore.com';
            this.aconexUrl = 'https://constructionandengineering.oraclecloud.com';
        }
    }

    getPlatform = (): Platform => {
        return 'azure';
    };

    getAuth = (): any | undefined => {
        return this.auth;
    };

    getParentUrl = (): string | undefined => {
        return this.parentUrl;
    };

    getAdminMicroserviceUrl = (): string => {
        return this.adminMicroserviceUrl;
    };

    getProxyMicroserviceUrl = (): string => {
        return this.proxyMicroserviceUrl;
    };

    getSyncMicroserviceUrl = (): string => {
        return this.syncMicroserviceUrl;
    };

    getMioAdminUrl = (): string => {
        return this.mioAdminUrl;
    };

    getTenant = (): Tenant => {
        return 'modelical';
    };

    getParentDomain = (): string => {
        return this.parentDomain;
    };

    getCookiesSubfix = (): string => {
        return this.cookiesSubfix;
    };

    getProcoreUrl = (): string => {
        return this.procoreUrl;
    };

    getAconexUrl = (): string => {
        return this.aconexUrl;
    };
}
